import { BookingCommonModel } from '../../recourse-booking/model/booking-common-model';
import { BookingSumRevenuesModel } from '../../recourse-booking/model/booking-sum-revenues-model';

import { RecourseCampaignNegotiationModel } from './recourse-campaign-negotiation-model';

export class RecourseCampaignDetailsModel {
  public campaignRecourseId: string;
  public recourseCampaignExId: string;
  public operationId: string;
  public topic: string;
  public affectedVehicles: bigint;
  public targetCars: bigint;
  public publishedDate: Date;
  public name1: string;
  public assignee: string;
  public assigneeFullName: string;
  public campaignCostsPrognosis: number;
  public businessYear: string;
  public fulfillmentDegree: number;
  public recourseCampaignStateId: bigint;
  public fkCampaignStateId: number;
  public campaignStateType: string;
  public campaignCreateDate: Date;
  public orderType: string;
  public markets: string;
  public supplier: string;
  public contactInternal: string;
  public contactExternal: string;
  public recourseCoordination: string;
  public recourseActualCostsEur: number;
  public costsPrognosisInternal: number;
  public costEditDate: Date;
  public partsRequest: string;
  public comment: string;
  public complaintDate: Date;
  public revenueOthersEur: number;
  public recourseClaimDate: Date;
  public recourseCampaignNegotiations: RecourseCampaignNegotiationModel[];
  public recourseBookingSumRevenues: BookingSumRevenuesModel;
  public bookings: BookingCommonModel[];
  public campaignOrigin: boolean;
}
